export enum Field {
  INPUT = 'INPUT',
  OUTPUT = 'OUTPUT',
  PRICE = 'PRICE',
}

export enum Rate {
  MUL = 'MUL',
  DIV = 'DIV',
}

export interface OrderState {
  readonly recipient?: string | null
  readonly independentField: Field
  readonly basisField: Field
  readonly typedValue: string
  readonly inputValue?: string
  readonly outputValue?: string
  readonly [Field.INPUT]: {
    readonly currencyId: string | undefined
  }
  readonly [Field.OUTPUT]: {
    readonly currencyId: string | undefined
  }
  readonly rateType: Rate
  orderList?: any
  cancel?: null,
  totalOrderList?: any
  historyTotalData?: any

}

// process.env.REACT_APP_HTTP_API REACT_APP_HTTP_API_ORDERLIST
const REACT_APP_HTTP_API = process.env.REACT_APP_HTTP_API_ORDERLIST

export const PENDING_ORDERLIST_DATA = REACT_APP_HTTP_API + "get_pending_orderlist_data"
export const FINISHED_ORDERLIST_DATA = REACT_APP_HTTP_API + "get_finished_orderlist_data"
export const ORDER_DETAIL = REACT_APP_HTTP_API + "get_order_detail?orderKey="


